<template>
    <svg v-if="props.isNavPrevious" width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="40" cy="40" r="40" fill="#464646" fill-opacity="0.5" />
        <path
            d="M28 21C26.9 21 26 21.8375 26 22.8843L26 57.1157C26 58.1625 26.9 59 28 59C29.1 59 30 58.1625 30 57.1157L30 22.8843C30 21.8375 29.1 21 28 21Z"
            fill="white"
        />
        <path
            d="M52.0676 21C52.3575 21 52.5507 21.1044 52.8406 21.2087C53.5169 21.5219 54 22.2525 54 23.0874L54 56.9041C54 57.7391 53.5169 58.4697 52.8406 58.7828C52.0676 
                59.2003 51.2947 58.9915 50.715 58.3653L34.5797 41.457C34.1932 41.0395 34 40.5176 34 39.9958C34 39.4739 34.1932 38.8477 34.5797 38.5346L50.715 21.6262C51.1015 
                21.2087 51.5845 21 52.0676 21ZM50.1353 51.9986L50.1353 28.0973L38.7343 40.1001L50.1353 51.9986Z"
            fill="white"
        />
    </svg>
    <svg v-else width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="40" cy="40" r="40" transform="rotate(-180 40 40)" fill="#464646" fill-opacity="0.5" />
        <path
            d="M52 59C53.1 59 54 58.1625 54 57.1157L54 22.8843C54 21.8375 53.1 21 52 21C50.9 21 50 21.8375 50 22.8843L50 57.1157C50 58.1625 50.9 59 52 59Z"
            fill="white"
        />
        <path
            d="M27.9324 59C27.6425 59 27.4493 58.8956 27.1594 58.7913C26.4831 58.4781 26 57.7475 26 56.9126L26 23.0959C26 22.2609 26.4831 21.5303 27.1594 21.2172C27.9324 
                20.7997 28.7053 21.0085 29.285 21.6347L45.4203 38.543C45.8068 38.9605 46 39.4824 46 40.0042C46 40.5261 45.8068 41.1523 45.4203 41.4654L29.285 58.3738C28.8985 
                58.7913 28.4155 59 27.9324 59ZM29.8647 28.0014L29.8647 51.9027L41.2657 39.8999L29.8647 28.0014Z"
            fill="white"
        />
    </svg>
</template>

<script setup lang="ts">
    const props = defineProps({
        isNavPrevious: {
            type: Boolean,
            required: true
        }
    });
</script>
